module.exports = __webpack_public_path__ + "static/media/JeanJimenezJoseph.9b9323f2.png";